(function(){
  "use strict";
  if(window.__orbitTrackingBootstrap)return;
  window.__orbitTrackingBootstrap=true;
  var API="https://orbit-membership-service.onrender.com";
  var pending=[];
  var providers={ga:false,meta:false};
  // V534 BOOTSTRAP-ORDER PROTECTION
  // Product/page inline scripts can execute before this deferred asset. They
  // deposit funnel events here instead of permanently capturing a missing
  // OrbitTracking object. Once this canonical loader boots, the queue is
  // drained through the same provider-aware track() path.
  var prebootQueue=Array.isArray(window.__orbitTrackingPrebootQueue)?window.__orbitTrackingPrebootQueue:[];
  window.__orbitTrackingPrebootQueue=prebootQueue;

  function loadScript(src,id){
    if(id&&document.getElementById(id))return;
    var s=document.createElement("script");if(id)s.id=id;s.async=true;s.src=src;
    document.head.appendChild(s);
  }
  function cleanParams(input){
    var out={};
    Object.keys(input||{}).forEach(function(key){
      var value=input[key];
      if(value===undefined||value===null||value==="")return;
      out[key]=value;
    });
    return out;
  }
  function sendToAvailable(entry){
    // A multi-provider event can wait for GA while Meta is already ready (or
    // vice versa). Persist per-provider delivery state so a later flush never
    // re-sends the side that already left successfully.
    var sentGa=Boolean(entry.sentGa),sentMeta=Boolean(entry.sentMeta),params=cleanParams(entry.params||{});
    if(entry.gaEvent&&!sentGa&&providers.ga&&typeof window.gtag==="function"){
      try{window.gtag("event",entry.gaEvent,params);sentGa=true;}catch(_){}
    }
    if(entry.metaEvent&&!sentMeta&&providers.meta&&typeof window.fbq==="function"){
      try{entry.eventId?window.fbq("track",entry.metaEvent,params,{eventID:entry.eventId}):window.fbq("track",entry.metaEvent,params);sentMeta=true;}catch(_){}
    }
    entry.sentGa=sentGa;entry.sentMeta=sentMeta;
    return {sentGa:sentGa,sentMeta:sentMeta};
  }
  function flush(){
    if(!providers.ga&&!providers.meta)return;
    var remaining=[];
    pending.forEach(function(entry){
      var result=sendToAvailable(entry);
      var stillNeedsGa=Boolean(entry.gaEvent&&!result.sentGa);
      var stillNeedsMeta=Boolean(entry.metaEvent&&!result.sentMeta);
      if(stillNeedsGa||stillNeedsMeta)remaining.push(entry);
    });
    pending=remaining.slice(-50);
  }
  function track(entry){
    if(!entry||(!entry.gaEvent&&!entry.metaEvent))return;
    pending.push({gaEvent:entry.gaEvent||"",metaEvent:entry.metaEvent||"",eventId:String(entry.eventId||""),params:cleanParams(entry.params||{}),sentGa:false,sentMeta:false});
    if(pending.length>50)pending.shift();
    flush();
  }
  function trackBeforeNavigation(entry,waitMs){
    track(entry);
    var delay=Math.max(0,Math.min(1500,Number(waitMs)||450));
    return new Promise(function(resolve){setTimeout(resolve,delay);});
  }
  window.OrbitTracking=window.OrbitTracking||{};
  window.OrbitTracking.track=track;
  window.OrbitTracking.trackBeforeNavigation=trackBeforeNavigation;
  window.OrbitTracking.version="V534.0.0";
  window.OrbitTracking.isReady=function(){return true;};
  function drainPrebootQueue(){
    if(!prebootQueue.length)return;
    var queued=prebootQueue.splice(0,prebootQueue.length);
    queued.forEach(function(entry){try{track(entry);}catch(_){}});
  }

  function startGa(id){
    if(!id||window.__orbitGaLoaded===id)return;
    window.__orbitGaLoaded=id;
    window.dataLayer=window.dataLayer||[];
    window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};
    window.gtag("js",new Date());
    window.gtag("config",id,{send_page_view:true});
    providers.ga=true;
    loadScript("https://www.googletagmanager.com/gtag/js?id="+encodeURIComponent(id),"orbit-ga-loader");
    flush();
  }
  function startMeta(id){
    if(!id||window.__orbitMetaLoaded===id)return;
    window.__orbitMetaLoaded=id;
    if(!window.fbq){
      var fbq=function(){fbq.callMethod?fbq.callMethod.apply(fbq,arguments):fbq.queue.push(arguments);};
      fbq.queue=[];fbq.loaded=true;fbq.version="2.0";window.fbq=fbq;
      loadScript("https://connect.facebook.net/en_US/fbevents.js","orbit-meta-loader");
    }
    window.fbq("init",id);
    window.fbq("track","PageView");
    providers.meta=true;
    flush();
  }
  var PROTECTED_META={
    ticket:"1198639419149834", // Orbit Show Tickets / dedicated Orbit-owned advertising dataset
    club:"922747680197686"     // MSTX / Orbit Collectors Club membership advertising
  };
  function hostBoundary(){
    var host=String(location.hostname||"").toLowerCase();
    var ticket=host==="orbitshowtickets.co.uk"||host==="www.orbitshowtickets.co.uk";
    var cardShow=host==="orbitcardshow.co.uk"||host==="www.orbitcardshow.co.uk";
    var club=host==="orbitcollectorsclub.com"||host==="www.orbitcollectorsclub.com";
    return {host:host,ticket:ticket,cardShow:cardShow,club:club,known:cardShow||ticket||club,siteKey:cardShow?"card_show":ticket?"show_tickets":"collectors_club"};
  }
  function apply(cfg){
    var boundary=hostBoundary();
    if(!boundary.known)return;
    var ticketHost=boundary.ticket;
    var profile=cfg&&cfg.siteProfiles&&cfg.siteProfiles[boundary.siteKey]||null;
    var configured=String(profile&&profile.metaPixelId||(boundary.cardShow?cfg.cardShowMetaPixelId:(ticketHost?cfg.ticketMetaPixelId:cfg.clubMetaPixelId))||"").trim();
    var pixelId=configured||String(boundary.cardShow?"":(ticketHost?PROTECTED_META.ticket:PROTECTED_META.club));
    // V532: when a site profile exists it is authoritative. Never fall back to
    // the legacy Collectors Club GA ID for Show Tickets, because doing so mixes
    // paid Club acquisition with ticket traffic when the ticket stream is
    // deliberately runtime-suppressed by the backend collision guard.
    var gaId=String(profile?profile.googleAnalyticsMeasurementId:(boundary.club?cfg.googleAnalyticsMeasurementId:"")||"").trim();
    startGa(gaId);
    startMeta(pixelId);
    // PROTECTED BUSINESS BOUNDARY:
    // Ticket host = Orbit Breaks dataset only. Club host = MSTX dataset only.
    // The optional upgrade becomes an MSTX lead only after the browser lands
    // on the Collectors Club EVENT_UPGRADE route.
    if(!ticketHost&&!boundary.cardShow){
      try{
        var q=new URLSearchParams(location.search||"");
        if(String(q.get("orbit_route")||"").toUpperCase()==="EVENT_UPGRADE"){
          window.fbq("track","Lead",{
            content_name:"Orbit Collectors Club Event Upgrade",
            content_category:"Membership Upgrade",
            orbit_event_id:String(q.get("event_id")||""),
            orbit_route:"EVENT_UPGRADE"
          });
        }
      }catch(_){}
    }
  }
  // V448.7: start the correct business pixel immediately. The remote config
  // remains authoritative when available, but a slow/blocked config request
  // must never leave the live paid-ad ticket site without its dedicated pixel.
  (function startProtectedMetaImmediately(){
    var boundary=hostBoundary();
    if(boundary.ticket)startMeta(PROTECTED_META.ticket);
    else if(boundary.club)startMeta(PROTECTED_META.club);
  })();

  // Drain product/page events that were emitted while this deferred asset was
  // still loading. Meta can leave immediately; GA remains in the internal
  // pending queue until the remote site profile starts gtag.
  drainPrebootQueue();
  try{
    if(typeof window.dispatchEvent==="function"&&typeof window.CustomEvent==="function")
      window.dispatchEvent(new window.CustomEvent("orbit:tracking-ready"));
  }catch(_){}

  fetch(API+"/api/public/tracking-config",{mode:"cors",credentials:"omit",cache:"no-store"})
    .then(function(r){if(!r.ok)throw new Error("tracking config "+r.status);return r.json();})
    .then(function(data){if(data&&data.success!==false)apply(data);})
    .catch(function(){/* Tracking failure must never affect storefront rendering. */});
})();